module.exports = __webpack_public_path__ + "assets/img/create-sm.4a66e202.jpg";